import { Loader } from "components/common/Icons/Loader/Loader";
import { RightIcon } from "components/common/Icons/RightIcon";
import { useAction } from "./useAction";
import { useButtonLabel } from "./useButtonLabel";

export const DesktopAction = () => {
    const { handleStartAction, processingState, dimensionsValid, isProcessing } = useAction();
    const isInactive = isProcessing || !dimensionsValid;
    const { getButtonLabel } = useButtonLabel(processingState, isProcessing);

    return (
        <div
            className={`${isProcessing ? "cursor-progress" : "cursor-pointer"} ${
                isInactive
                    ? "bg-irGray-400 dark:bg-darkSurface-600 dark:hover:bg-darkSurface-500 hover:bg-irGray-400"
                    : "bg-irBlue-200 dark:bg-darkPrimary-100 dark:hover:bg-darkPrimary-200 hover:bg-irBlue-400"
            } text-white text-center flex items-center justify-center gap-2 capitalize font-semibold px-6 py-3 lg:py-4 rounded-xl lg:text-2xl mx-4`}
            onClick={(e) => {
                e.stopPropagation();
                handleStartAction();
            }}
            data-testid={`enlarge-image-${isInactive ? "inactive" : "active"}-button`}
        >
            <div className="">{getButtonLabel()}</div>
            {isProcessing ? (
                <div>
                    <div className="hidden lg:block">
                        <Loader className="stroke-white" width={24} height={24} />
                    </div>
                    <div className="lg:hidden">
                        <Loader className="stroke-white" width={10} height={16} />
                    </div>
                </div>
            ) : (
                <div>
                    <div className="hidden lg:block">
                        <RightIcon className="fill-white" width={24} height={24} />
                    </div>
                    <div className="lg:hidden">
                        <RightIcon className="fill-white" width={16} height={16} />
                    </div>
                </div>
            )}
        </div>
    );
};
